import { render, staticRenderFns } from "./planning-budget-item.vue?vue&type=template&id=6824530c&"
import script from "./planning-budget-item.vue?vue&type=script&lang=js&"
export * from "./planning-budget-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports